import React from 'react'
import Searchbar from 'blocks.app/searchbar/searchbar'
import translate from 'core/translate'
import { item } from 'theme'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { IRecordWithStrings } from 'core/helpers'
import { AutocompleteItem, IAutocompleteProps } from 'blocks.app/searchbar/__autocomplete/autocomplete'
import { ISearchbarProps } from 'blocks.app/searchbar/searchbar'
import { DropdownValue } from 'blocks.simple/dropdown/dropdown.local.methods'

interface IScheduleSearchProps extends Omit<IAutocompleteProps, 'isOpen' | 'onSelect' | 'query'> {
    id?: string | number
    placeholder?: string
    query: IRecordWithStrings
    onChange: (value: string) => void
    onFocus?: (value: string) => void
    viewValue: DropdownValue
    onViewChange: NonNullable<ISearchbarProps['onViewChange']>
    onClickView?: ISearchbarProps['onClickView']
    onClick?: ISearchbarProps['onClick']
    onSelect: (item: AutocompleteItem) => void
}

const ScheduleSearch = (p_: IScheduleSearchProps) => {
    return (
        <div className={item.rel}>
            <Searchbar
                id={p_.id}
                mod={'withLightBorder'}
                placeholder={p_.placeholder}
                value={p_.query.name}
                onChange={p_.onChange}
                onFocus={p_.onFocus}
                view={{
                    icon: 'view',
                    iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
                    iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
                    value: p_.viewValue,
                    options: [
                        { id: 'month', name: translate('month') },
                        { id: 'week', name: translate('week') },
                        { id: 'day', name: translate('dayD') },
                    ],
                }}
                onViewChange={p_.onViewChange}
                onClickView={p_.onClickView}
                onClick={p_.onClick}
                search={{
                    onSelect: p_.onSelect,
                    props: { ...p_ },
                }}
                viewTestClass={'test-schedule-display'}
            />
        </div>
    )
}

export default ScheduleSearch
